export function FontFamily (pEditor)
{
  let prevFontFamily,
      currentTextFontIds,
      webKitStyles = {};


  this.getCurrentTextFont = () =>
  {
    let fontFamily = getCurrentFullTextFont();

    if (fontFamily)
    {
      fontFamily = fontFamily.split(',');
      fontFamily = fontFamily[0].replace(/^[\s\n\r]+|[\s\n\r]+$/g, '');
    }
    else
    {
      fontFamily = '';
    }

    return fontFamily;
  };


  function getCurrentFullTextFont ()
  {
    let fontFamily;

    if (!(BEditor.browser.isIE && ((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevFontFamily != null))
    {
        if (currentTextFontIds != null)
        {
          fontFamily = currentTextFontIds;
        }
        else
        {
          fontFamily = pEditor.style.helpers.getCurrentStyleInRange('fontFamily');
        }

      prevFontFamily = fontFamily || '';
    }

    return prevFontFamily;
  }


  this.openTextFontDropdown = (pButton) =>
  {
    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', '');
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'setTextFont');
    }
  };


  function setTextFont (pButton)
  {
    let pParameters,
        saveRangePoints,
        textFontIds,
        currentRange,
        isSaveCurrentRangeCollapsed;

    pEditor.pDropdown = pButton.getDropdown();

    if (pEditor.pDropdown)
    {
      pParameters = pEditor.pDropdown.getReturnedParameters();
    }

    if (pParameters && pParameters.selectedStyleId)
    {
      textFontIds = pParameters.selectedStyleId;
    }

    pEditor.closeDropdown(pButton);

    if (textFontIds)
    {
      pEditor.range.stopCheckSelection();

      if (!BEditor.browser.isIE)
      {
        pEditor.iFrameDoc.execCommand('styleWithCSS', false, false);
      }
      else
      {
        pEditor.range.restoreBookmark();
      }

      currentRange = pEditor.range.getCurrent();
      isSaveCurrentRangeCollapsed = currentRange.collapsed;

      if (BEditor.browser.isWebKit)
      {
        fixWebKit(true);
      }

      pEditor.iFrameDoc.execCommand('fontname', false, textFontIds);

      if (BEditor.browser.isWebKit)
      {
        fixWebKit(false);
      }

      if (isSaveCurrentRangeCollapsed)
      {
        currentTextFontIds = textFontIds;
        BEditor.domHandlers.addHandler(pEditor.iFrameDoc.body, 'keypress', clearCurrentTextFontIds);
        BEditor.domHandlers.addHandler(pEditor.iFrameDoc.body, 'mousedown', clearCurrentTextFontIds);
        pEditor.pThis.addHandler('blur', clearCurrentTextFontIds, 'clearCurrentTextFontIds');
      }

      pEditor.range.restoreBookmark();
      pButton.refreshState();
    }
    else
    {
      return false;
    }
  }


  function fixWebKit (isPreFix)
  {
    let elements = pEditor.iFrameDoc.body.getElementsByTagName('*');

    for (let i = 0; i < elements.length; i++)
    {
      let waContentId = elements[i].getAttribute('data-wacontent');

      if (waContentId != null)
      {
        if (isPreFix)
        {
          webKitStyles[waContentId] = elements[i].getAttribute('style');
        }
        else
        {
          let elementStyle = elements[i].getAttribute('style');

          if (waContentId in webKitStyles && elementStyle !== webKitStyles[waContentId])
          {
            if (!webKitStyles[waContentId])
            {
              elements[i].removeAttribute('style');
            }
            else
            {
              elements[i].setAttribute('style', webKitStyles[waContentId]);
            }
          }
        }
      }
    }

    if (!isPreFix)
    {
      webKitStyles = {};
    }
  }


  function clearCurrentTextFontIds ()
  {
    currentTextFontIds = null;
    pEditor.pThis.removeHandler('blur', 'clearCurrentTextFontIds');
  }


  this.getCurrentFullTextFont = getCurrentFullTextFont;
  this.setTextFont = setTextFont;
}